export default __webpack_public_path__ + "static/media/AboutImage.f83ede84.JPG";